const getLoaderSize = (size) => {
    if (size === 'xs') {
        return '2xs';
    }
    return 'xs';
};
export default getLoaderSize;
